import { css } from 'styled-components';
export const BKJThemeListItem = {
    LeftAlignAlternatingBackgroundColor: {
        common: css `
      &:hover {
        background-color: ${({ theme }) => theme.colors.Grey2};
      }
      &:nth-child(odd) {
        background-color: ${({ theme }) => theme.colors.Grey1};
      }
    `,
        targeted: css `
      background-color: ${({ theme }) => theme.colors.Grey2} !important;
    `,
    },
    SpaceBetween: {
        common: css `
      justify-content: space-between;
      &:hover {
        background-color: ${({ theme }) => theme.colors.Grey2};
      }
    `,
        targeted: css `
      background-color: ${({ theme }) => theme.colors.Grey2} !important;
    `,
    },
    LeftAlignRowReverse: {
        common: css `
      flex-direction: row-reverse;
      &:hover {
        background-color: ${({ theme }) => theme.colors.Grey2};
      }
    `,
        targeted: css `
      background-color: ${({ theme }) => theme.colors.Grey2} !important;
    `,
    },
    RowReverseSpaceBetween: {
        common: css `
      flex-direction: row-reverse;
    `,
        targeted: css `
      background-color: ${({ theme }) => theme.colors.Grey2} !important;
    `,
    },
};
//# sourceMappingURL=BKJListItem.theme.js.map